export default __webpack_public_path__ + "static/media/Rectanglethree.188275dd.svg";